import { library, IconDefinition } from '@fortawesome/fontawesome-svg-core'; // Core SVG
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'; // Integration
import { iconList } from '@/styles/icons/icons';
import { ICustomIcons } from './types';

const buildIconDefinitions = (): IconDefinition[] => {
    const icons: IconDefinition[] = [];
    Object.keys(iconList).forEach((iconName: string) => icons.push(iconList[iconName].icon));

    return icons;
};
const icons = buildIconDefinitions();
library.add(...icons);

//TODO: ez miért egy fn?
const buildCustomIcons = (): ICustomIcons => {
    const CustomIcons: ICustomIcons = {};

    Object.keys(iconList).forEach((icon) => {
        CustomIcons[icon] = {
            component: FontAwesomeIcon,
            props: {
                icon: iconList[icon].classNames,
            },
        };
    });

    return CustomIcons;
};

const iconfont = 'faSvg';

export { buildCustomIcons, iconfont };
